import React from 'react';
import { useAppLayoutOptional } from '../contexts/AppLayoutContext';
import RintintinLoader from './RintintinLoader/RintintinLoader';

/** Fallback minimal pour React.lazy — évite un flash blanc total. */
const RouteFallback: React.FC = () => {
  const { isNative } = useAppLayoutOptional();

  if (isNative) {
    return (
      <div
        className="route-fallback route-fallback--native"
        style={{
          minHeight: '50vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--native-cream, #faf6f3)',
        }}
        aria-live="polite"
        aria-busy="true"
      >
        <RintintinLoader size="medium" variant="primary" />
      </div>
    );
  }

  return (
    <div
      className="route-fallback"
      style={{
        minHeight: '40vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <RintintinLoader
        className="rintintin-loader-page"
        size="large"
        variant="primary"
        text="Chargement…"
      />
    </div>
  );
};

export default RouteFallback;
